import { call, put, fork } from 'redux-saga/effects'
import moment from 'moment'
import firebase from '../config/firebase'
import DynamicFeeActions from '../reducers/dynamicFeeReducer'

export function* syncDynamicFees() {
  try {
    const dbRef = firebase.database().ref('dynamic_fees')

    const response = yield call([dbRef, dbRef.once], 'value')

    const dynamicFees = {}
    yield put(DynamicFeeActions.setDynamicFeeLoading(true))

    response.forEach(dynamicFee => {
      const fee = dynamicFee.val()

      if (!fee.archived) {
        dynamicFees[dynamicFee.key] = { ...fee, key: dynamicFee.key }
      }
    })

    yield put(DynamicFeeActions.setDynamicFeeLoading(false))
    yield put(DynamicFeeActions.setDynamicFees(dynamicFees))
  } catch (error) {
    yield put(DynamicFeeActions.setDynamicFeeLoading(false))
    alert(error)
  }
}

export function* saveDynamicFee({ data, callBack }) {
  const dynamicFeeObj = {}
  const dbRef = firebase.database().ref()
  const key = data.key || dbRef.push().key

  try {
    dynamicFeeObj[`dynamic_fees/${key}/name`] = data.name
    dynamicFeeObj[`dynamic_fees/${key}/description`] = data.description
    dynamicFeeObj[`dynamic_fees/${key}/type`] = data.type
    dynamicFeeObj[`dynamic_fees/${key}/go_to`] = data.go_to

    if (!data.key) dynamicFeeObj[`dynamic_fees/${key}/created_at`] = Number(moment().format('x'))
    yield put(DynamicFeeActions.setDynamicFeeAdding(true))
    yield call([dbRef, dbRef.update], dynamicFeeObj)
    yield put(DynamicFeeActions.setDynamicFee(key, data))
    yield put(DynamicFeeActions.setDynamicFeeAdding(false))
    yield call(callBack)
  } catch (e) {
    alert(e)
    yield put(DynamicFeeActions.setDynamicFeeAdding(false))
  }
}

export function* deleteFee({ feeKey }) {
  try {
    const updateRef = firebase.database().ref()

    const updates = {}
    updates[`dynamic_fees/${feeKey}/archived`] = true

    yield fork([updateRef, updateRef.update], updates)
  } catch (e) {
    alert(e)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/dynamicFeeSaga.js